export default __webpack_public_path__ + "static/media/sleepingkitten.b74c745e.jpg";